import { ChangeDetectionStrategy, Component, Input, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { EQuestionType } from 'src/app/models/questionType.model';
import { QuestionDisplayComponent } from '../question-display/question-display.component';
import { EImageStatus } from 'src/app/models/EnumImageStatus';
import { QuestionnaireApiService } from 'src/app/services/questionnaire-api.service';
import { Observable, combineLatest } from 'rxjs';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { AnswersStore } from 'src/app/store/answers-store';

@Component({
    selector: 'que-warp-question-display',
    imports: [CommonModule, QuestionDisplayComponent],
    templateUrl: './warp-question-display.component.html',
    styleUrls: ['./warp-question-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarpQuestionDisplayComponent implements OnInit {
  @Input() question!: Question;
  eQuestionType = EQuestionType;
  @Input() isPreview = false;
  @Input() viewAnswer = false;

  questionSignal$ = signal<Question | null>(null);
  #questionnaireApiService = inject(QuestionnaireApiService);
  #questionnaireStore = inject(QuestionnaireStore);
  #answerStore = inject(AnswersStore);
  answers$ = toSignal(this.#answerStore.answers$);

  currentStepQuestions$ = toSignal(this.#questionnaireStore.currentStepQuestions$);
  currentStepIndex$ = toSignal(this.#questionnaireStore.isCurrentStepQuestions$);

  isUser$ = toSignal(this.#questionnaireStore.isUser$);
  showLastState = false;
  ngOnInit(): void {
    this.questionSignal$.set(this.question)
    if (this.question.type.id == EQuestionType.Image) {
      if (!this.question.imageBase64 && this.question.statusImage == EImageStatus.Load) {

        this.#questionnaireApiService.getImageByQuestioneId(this.question.id)
          .subscribe(image => {
            this.question = { ...this.question, imageBase64: image.base64, statusImage: EImageStatus.Saved } as Question;
            this.questionSignal$.set(this.question);
            this.#questionnaireStore.SaveImageFromLoad({ questionId: this.question.id, image: image.base64 })
          })
      }
    }
  }
  IsShowFollowUpQuestion() {
    if (!this.isUser$()) {
      return true;
    }
    else {
      var question = this.currentStepQuestions$()?.find(ans => ans.id == this.question.parentFollowUpQuestionId);
      var parentAnswer = this.answers$()?.find(ans => ans.questionId == this.question.parentFollowUpQuestionId);
      if (question?.type.id == EQuestionType.Autocomplete || question?.type.id == EQuestionType.Mark) {
        var x = parentAnswer?.optionItemGuid == this.question.followAnswerOptionItemGuid;
        if (this.showLastState == true && x == false) {
          this.#answerStore.deleteAnswerById(this.question.id)
        }
        this.showLastState = x;
        return x;
      }
      if (question?.type.id == EQuestionType.Multi) {
        var y = parentAnswer?.multiOptionsAnswer?.includes(this.question.followAnswerOptionItemGuid ?? "eeeeeeeeeeeeeeeeeeeeeeeeeeeeee") ?? false;
        if (this.showLastState == true && y == false) {
          this.#answerStore.deleteAnswerById(this.question.id)
        }
        this.showLastState = y;
        return y;
      }
      return false;
    }
  }
}

